
const EditCertification = () => {
  return (
    <div>EditCertification</div>
  )
}

export default EditCertification